var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.subtitle)?_c('h2',{staticClass:"title mt-4 mb-2"},[_vm._v(_vm._s(_vm.title))]):_c('h3',{staticClass:"mt-4 mb-2"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('Chart',{attrs:{"chart-data":_vm.datasets,"height":200,"label":_vm.coin}})],1)],1)],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8194b646","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/dashboard/ChartWrapper.vue
// module id = +PRo
// module chunks = 0